import styled from "styled-components";
export const Layout = styled.button `
  background-color: ${({ $isSelected }) => $isSelected ? "#DBE4FC" : "#F3F5FD"};
  border: 1px solid;
  border-color: ${({ $isSelected, theme }) => $isSelected ? theme.color.s1 : "#DBE4FC"};
  border-radius: 20px;
  cursor: pointer;
  display: block;
  height: 32px;
  padding: 4px;
  width: 32px;
  &:hover {
    background-color: #dbe4fc;
    filter: brightness(1.05);
  }
`;
export const Color = styled.div `
  background-color: ${({ $color }) => $color};
  border-radius: 20px;
  height: 100%;
  width: 100%;
`;
